const GET_DIMENSIONS = 'dimensionStatus/GET_DIMENSIONS'

export const getDimensions = (payload) => ({
  type: GET_DIMENSIONS,
  payload: payload,
})
type DimensionsAction = ReturnType<typeof getDimensions>
type DimensionState = {
  dimensions: Object
}
export const initialState: DimensionState = {
  dimensions: {},
}

export default function dimensionStatus(
  state: DimensionState = initialState,
  action: DimensionsAction,
) {
  switch (action.type) {
    case GET_DIMENSIONS:
      return {
        ...state,
        dimensions: action.payload,
      }

    default:
      return state
  }
}
